/* eslint-disable max-len */
import React, { useState } from 'react';
import Buttons from '../../components/Buttons';
import DashboardWrap from '../../components/DashboardWrap';
import PlusIcon from '../../svgs/PlusIcon';

import Styles from './RealtorTrackingCode.module.scss';
import RealtorTrackingDashboard from './RealtorTrackingDashboard';
import RealtorTrackingRecordSection from './RealtorTrackingRecord';

const RealtorTrackingCode = () => {
  const [isShowGenerateCodeModal, setIsShowGenerateCodeModal] = useState(false);

  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__header}>
          <div className={Styles.wrapper__title}>Realtor’s Tracking Code</div>
          <div className={Styles.wrapper__buttonContainer}>
            <Buttons
              name="Generate new tracking code"
              Icon={PlusIcon}
              onClick={() => setIsShowGenerateCodeModal(true)}
            />
          </div>
        </div>
        <RealtorTrackingDashboard />
        <RealtorTrackingRecordSection
          isShowGenerateCodeModal={isShowGenerateCodeModal}
          setIsShowGenerateCodeModal={(data: boolean) => setIsShowGenerateCodeModal(data)}
        />
      </div>
    </DashboardWrap>
  );
};

export default RealtorTrackingCode;
